import { t, getLang } from '../i18n';
import { formatBusinessHours, resolveOfflineStatus } from './launcher-engagement.js';

/** The translated status line for when no agent is online. '' means show none. */
export default function offlineStatusLine(theme) {
    const hours = formatBusinessHours(theme && theme.businessHours, getLang());
    return resolveOfflineStatus(theme, { hoursLine: hours ? t('status.business_hours', { hours }) : '' });
}
